<template>
  <sea-page title="Pagina di errore">
    <div class="row">
      <div class="col-md-3">
        <span class="hipster img-fluid rounded"></span>
      </div>
      <div class="col-md-9">
        <h1>Pagina di errore!</h1>
        <div v-if="errorMessage">
          <div class="alert alert-danger">{{ errorMessage }}</div>
        </div>
        <div v-if="error403">
          <div>
            Non si dispongono i privilegi sufficienti per accedere a questa
            pagina.
          </div>
          <div v-if="!authenticated">
            A breve verrete indirizzati alla pagina di
            <router-link to="/">Login</router-link>
          </div>
        </div>
        <div v-if="error404" class="alert alert-warning">
          La pagina non esiste.
        </div>
      </div>
    </div>
  </sea-page>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      errorMessage: null,
      error403: false,
      error404: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let errorMessage = null;
      let error403 = false;
      let error404 = false;

      if (to.meta.errorMessage) {
        errorMessage = to.meta.errorMessage;
      }

      if (to.meta.error403) {
        error403 = to.meta.error403;
      }

      if (to.meta.error404) {
        error404 = to.meta.error404;
      }

      vm.init(errorMessage, error403, error404);
    });
  },
  methods: {
    init(errorMessage, error403, error404) {
      this.errorMessage = errorMessage;
      this.error403 = error403;
      this.error404 = error404;

      if (!this.authenticated && this.error403) {
        // this.loginService().openLogin((<any>this).$root);
        setTimeout(() => {
          this.$router.push("/");
        }, 3000);
      }
    },
  },
  computed: {
    ...mapGetters({
      authenticated: "account/authenticated",
    }),
  },
};
</script>
